import React from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect ,useCallback } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Sentence from "../../QuestionPage/DragAndDrop";
import ExamPanel from "../ExamPanel";
// Fetching Data from the API]

// End

// Page Html
export default function ReArrangeSentenceMockPage({ question , onInputChange , maxQuestion ,questionNumber }) {
  // End
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/");
  };

  const [originalSentences, setOriginalSentences] = useState([]);
  const [draggableSentences, setDraggableSentences] = useState([]);
  const [Title, setTitle] = useState("");
  const [originalAnswer, setOriginalAnswer] = useState("");


  useEffect(() => {
    if (question && question.q_title) {
      setTitle(question.q_title);
      const fetchedSentences = question.option.map(option => ({ ...option, text: option.options }));
      
      const shuffledOriginal = shuffleArray([...fetchedSentences]);
      const shuffledDraggable = shuffleArray([...fetchedSentences]);

      setOriginalSentences(shuffledOriginal);
      setDraggableSentences(shuffledDraggable);
    }
  }, [question]);

  console.log("Original Sentences:", originalSentences);
  console.log("Draggable Sentences:", draggableSentences);


  const updateAnswer = useCallback(() => {
    const userOrder = draggableSentences.map((sentence) => sentence.index + 1);
    console.log("User's order of sentences:", userOrder.join(","));
    
    const answer = userOrder.join(",");
    onInputChange(answer);
  }, [draggableSentences, onInputChange]);

  useEffect(() => {
    updateAnswer();
  }, [draggableSentences]);
  

  const moveSentence = (dragIndex, hoverIndex, boxType) => {
    const sourceArray = boxType === "original" ? originalSentences : draggableSentences;
    const newSentences = [...sourceArray];
    const draggedSentence = newSentences[dragIndex];

    newSentences.splice(dragIndex, 1);
    newSentences.splice(hoverIndex, 0, draggedSentence);

    if (boxType === "original") {
      setOriginalSentences(newSentences);
    } else {
      setDraggableSentences(newSentences);
    }
  };

  const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };







  return (
    <ExamPanel
      eyebrow="Reading"
      title="Re-order Paragraphs"
      questionLabel={`Question ${questionNumber} of ${maxQuestion}`}
      instructions="Arrange the text boxes in the correct order to form a coherent paragraph."
    >
        <DndProvider backend={HTML5Backend}>
          <div className="grid gap-5 lg:grid-cols-2">
            <div className="min-w-0 rounded-md border border-slate-200 bg-slate-50 p-4">
              <h2 className="mb-3 text-lg font-extrabold text-gray-900">Source sentences</h2>
              <div className="space-y-3 rounded-md border border-slate-200 bg-white p-4">
                {originalSentences.map((sentence, index) => (
                  <div key={sentence.id} className="rounded-md border border-slate-200 bg-slate-50 p-3 text-sm leading-6 text-gray-700">
                    {sentence.options}
                  </div>
                ))}
              </div>
            </div>
            <div className="min-w-0 rounded-md border border-slate-200 bg-slate-50 p-4">
              <h2 className="mb-3 text-lg font-extrabold text-gray-900">Your order</h2>
              <div className="space-y-3 rounded-md border border-violet-100 bg-violet-50 p-4">
                {draggableSentences.map((sentence, index) => (
                  <Sentence
                    key={sentence.id}
                    sentence={sentence}
                    index={index}
                    moveSentence={(dragIndex, hoverIndex) => moveSentence(dragIndex, hoverIndex, "draggable")}
                  />
                ))}
              </div>
            </div>
          </div>
        </DndProvider>
    </ExamPanel>
  );
}

